import React from 'react'
import './info.css'
import { SlScreenSmartphone } from 'react-icons/sl'
import { Link } from 'react-router-dom'

const Info = () => {
  return (
    <div className='p2'>
        <article className='numcontainer p2'>
                <div className='phonenumber p2'><span className='phonespan padadd'><SlScreenSmartphone className='num iconss' /><p className='num'>+234 808 531 2366</p></span></div>
                <h1 className='p2 infoh1'>Let's Find You Together The Place You Deserve</h1>
                <p>Your perfect space is waiting – a dream home, ideal office, or cozy apartment. We’ll help you find it. Tell us what you need today!</p>
                <div className='auto'>
                    <button className='btn'><Link to='/contact' className='propbtn'>Contact Us</Link></button>
                </div>
        </article> 
    </div>
  )
}

export default Info